import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import eventsCenter from 'src/classes/EventsCenter';
import { Portal } from 'src/classes/Portal';
import { HomePage } from '../home/home.page';
import { Place, PlacesList } from 'src/classes/dataClasses/Places';
import { WeatherService, connectionStatus } from 'src/classes/WeatherService';
import { IonModal, ModalController } from '@ionic/angular';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { GlobalService } from '../services/global.service';
import { WebsocketService } from '../services/websocket.service';
import { MessagesModalComponent } from '../messages-modal/messages-modal.component';
import { MiniMapComponent } from '../mini-map/mini-map.component';
import MainScene from '../Scenes/MainScene';
import { GpsModeManager } from 'src/classes/GpsMode';
import { AudioUploaderComponent } from '../audio-uploader/audio-uploader.component';

@Component({
  selector: 'app-settings-modal',
  templateUrl: './settings-modal.component.html',
  styleUrls: ['./settings-modal.component.scss'],
})
export class SettingsModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(IonModal) modal: IonModal;
  @ViewChild('toggle', { read: ElementRef }) toggles: ElementRef[];
  private _toggleListeners: Array<() => void> = [];
  gpsModeState: boolean = false;

  geoPlaces: Place[] = PlacesList;
  weatherService = WeatherService;
  connectionStatus = connectionStatus;
  gpsMode: GpsModeManager;

  constructor(
    public authenticator: AuthenticatorService,
    public globalService : GlobalService,
    public websocketService: WebsocketService,
    public modalCtrl: ModalController,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    console.log(this.globalService.$loggedIn.value);
    // Make sure that we know when the modal is closed
    // so we know to re-open it when settings button is clicked
    this.modal.onDidDismiss().then(() => {
      HomePage.settingsModalActive = false;
    })
    this.gpsMode = MainScene.gpsMode;
    // initialize toggle state
    this.gpsModeState = !!(this.gpsMode && this.gpsMode.isConnected);

    // Keep UI in sync with gps mode global state
    GlobalService.$gpsModeState.subscribe({
      next: state => {
        this.gpsModeState = state === GlobalService.modeState.On;
        this.cdr.detectChanges();
      }
    });
  }

  ngAfterViewInit() {
    // Add capture-phase non-passive listeners to prevent sliding gestures
    setTimeout(() => {
      const elArray = Array.from(document.querySelectorAll('ion-toggle')) as HTMLElement[];
      elArray.forEach((el) => {
        const onMove = (ev: Event) => { ev.preventDefault(); ev.stopPropagation(); };
        // add as capture and non-passive so we can preventDefault()
        el.addEventListener('touchmove', onMove, { capture: true, passive: false });
        el.addEventListener('pointermove', onMove, { capture: true, passive: false });
        this._toggleListeners.push(() => {
          el.removeEventListener('touchmove', onMove as EventListener, { capture: true, passive: false } as any);
          el.removeEventListener('pointermove', onMove as EventListener, { capture: true, passive: false } as any);
        });
      });
    }, 200);
  }

  ngOnDestroy() {
    // remove listeners
    this._toggleListeners.forEach(remove => remove());
  }

  closeMenu(){
    HomePage.modalCtrl.dismiss();
  }

  toggleMusic(event){
    console.log("toggleMusic called");
    GlobalService.$musicPlaying.next(event.detail.checked);
  }

  onlineModeChanged() {
    console.log('onlineModeChanged');

    if(!this.websocketService.isConnected && !this.websocketService.isConnecting){
      this.websocketService.connect();
    }
    else if (this.websocketService.isConnected){
      this.websocketService.closeConnection();
    }
  }

  placeSelected(place) {
    eventsCenter.emit('placeSelected', place);
  }

  hasBeenGpsVisited(place: string) {
    return Portal.gpsVisitedPlaces.indexOf(place) > -1;
  }

  static getActiveLevelName(): string{
    const activeScenes = HomePage.phaserGame.scene.getScenes(true);
    const activeLevel = activeScenes.find(scene => scene.scene.key !== "UIScene");
    console.log(`activeLevel: ${activeLevel.scene.key}`);
    return `${activeLevel.scene.key}`;
  }

  openMessagesModal() {
    this.modalCtrl.create({
      component: MessagesModalComponent
    }).then(modal => modal.present());
  }

  openMiniMapModal() {
    console.log("openMiniMapModal called");
    this.modalCtrl.create({
      component: MiniMapComponent
    }).then(modal => modal.present());
  }

  openAudioUploaderModal() {
    console.log("openAudioUploaderModal called");
    this.modalCtrl.create({
      component: AudioUploaderComponent
    }).then(modal => modal.present());
  }

  async gpsToggleClicked() {
    // call wrapper so toggle UI updates after actual state change
    try {
      // Call the gps mode toggle and then update UI from the real state
      await this.gpsMode.toggleGpsMode();
      this.gpsModeState = !!(this.gpsMode && this.gpsMode.isConnected);
      this.cdr.detectChanges();
    } catch (e) {
      console.warn('gpsToggleClicked error', e);
      // revert UI if error
      this.gpsModeState = !!(this.gpsMode && this.gpsMode.isConnected);
      this.cdr.detectChanges();
    }
  }
}
